import React from 'react';

const LoadingSpinner = ({ message = 'Loading...', fullScreen = false }) => {
  const containerStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '2rem',
    textAlign: 'center',
    ...(fullScreen && {
      minHeight: '100vh',
      backgroundColor: 'var(--color-background)',
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      zIndex: 1000
    })
  };

  return (
    <div style={containerStyle}>
      <div style={{
        maxWidth: '400px',
        width: '100%'
      }}>
        <h2 style={{ 
          fontSize: '1.5rem', 
          fontWeight: '600', 
          color: 'var(--color-text-primary)', 
          marginBottom: '1rem',
          margin: '0 0 1rem 0'
        }}>
          {message}
        </h2>
        <div className="loading-bar-container" style={{ marginBottom: '1rem' }}>
          <div className="loading-bar"></div>
        </div>
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          gap: '0.5rem',
          opacity: 0.6
        }}>
          <div style={{
            width: '8px',
            height: '8px',
            borderRadius: '50%',
            backgroundColor: 'var(--color-accent-blue)',
            animation: 'pulse 1.5s ease-in-out infinite'
          }}></div>
          <div style={{
            width: '8px',
            height: '8px',
            borderRadius: '50%',
            backgroundColor: 'var(--color-accent-blue)',
            animation: 'pulse 1.5s ease-in-out infinite 0.3s'
          }}></div>
          <div style={{
            width: '8px',
            height: '8px',
            borderRadius: '50%',
            backgroundColor: 'var(--color-accent-blue)',
            animation: 'pulse 1.5s ease-in-out infinite 0.6s'
          }}></div>
        </div>
      </div>
    </div>
  );
};

export default LoadingSpinner;
